import { SelfServiceAPI } from '../types';

export const getBookingDetailsPageLink = (bookingId: string) => `/bookings/${bookingId}`;

export const getBookingCancellationQuotePageLink = (bookingId: string, stateSuffix = '') =>
  `/bookings/${bookingId}/cancellation-quote${stateSuffix}`;

export const getChangeDatesRequestPageLink = (bookingId: string, stateSuffix = '') =>
  `/bookings/${bookingId}/change-date-request${stateSuffix}`;

export const getChangeDatesPageLink = (bookingId: string, stateSuffix = '') => `/bookings/${bookingId}/change-date${stateSuffix}`;

export const getBookingListPageLink = () => '/bookings';

export const getUpdatePaymentMethodPageLink = (bookingId: string, stateSuffix = '') =>
  `/bookings/${bookingId}/update-payment-method${stateSuffix}`;

export const getChangeYourBookingLink = (booking: SelfServiceAPI.Booking) => {
  switch (true) {
    case booking.flags.isDateAmendableInApp:
      return getChangeDatesPageLink(booking.id);
    case booking.flags.isChangeDatesRequestEnabled:
      return getChangeDatesRequestPageLink(booking.id);
    default:
      return null;
  }
};
